import { useOctopusFeatureToggle } from "~/hooks/useOctopusFeatureToggle";
export function useEphemeralEnvironmentsConfigWizard() {
    return useOctopusFeatureToggle("ephemeral-environments-config-wizard", false);
}
